unit ShowPos;

interface

uses System.SysUtils, System.Variants, System.Classes, System.StrUtils, Vcl.Graphics,
     Vcl.Controls, Vcl.Forms, Vcl.Dialogs, WebBasis, Data.DB, XData.Web.JsonDataset, XData.Web.Dataset,
     VCL.TMSFNCCustomComponent, VCL.TMSFNCBitmapContainer, WEBLib.Controls, WEBLib.Dialogs, VCL.TMSFNCTypes,
     VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes,  VCL.TMSFNCCustomControl,  XData.Web.Client,
     VCL.TMSFNCToolBar, WEBLib.ExtCtrls, VCL.TMSFNCMapsCommonTypes, VCL.TMSFNCWebBrowser, VCL.TMSFNCMaps, Vcl.StdCtrls,
     WEBLib.StdCtrls, Web, Js;

[async] procedure Show_FzgPos( aID_Fahrzeug : Integer ); async;

type
  TfrmShowPos = class(TfrmWebBasis)
    WebPanel1: TPanel;
    btnClose: TTMSFNCToolBarButton;
    Map: TTMSFNCMaps;
    lbKennzeichen: TLabel;
    btnPosition: TTMSFNCToolBarButton;
    btnFzgSel12: TTMSFNCToolBarButton;
    procedure btnCloseClick(Sender: TObject);
    [async] procedure Fzg_Pos_Laden; async;
    [async] procedure WebFormShow(Sender: TObject); async;
    [async] procedure btnFzgSel12Click(Sender: TObject); async;
    procedure Positionieren(Sender: TObject);

  private
    iID_Fahrzeug : Integer;
    dLat : Double;
    dLon : Double;

  public

  protected procedure LoadDFMValues; override; end;

var frmShowPos: TfrmShowPos;

implementation

{$R *.dfm}

uses UnitMain, GlobalWeb, SpediFucsDatenmodul, GetStammdaten;

//====================================================================================================================//

procedure Show_FzgPos( aID_Fahrzeug : Integer );
begin


  frmShowPos := TfrmShowPos.Create(application);
  frmShowPos.iID_Fahrzeug := aID_Fahrzeug;
  frmShowPos.Popup   := True;

  // used to manage Back button handling to close subform
  window.location.hash := 'subform';

  // load file HTML template + controls
  await( TfrmShowPos, frmShowPos.Load() );

  await( frmShowPos.Fzg_Pos_Laden );

  Try   // excute form and wait for close
    await( TModalResult, frmShowPos.Execute);
  Finally
    frmShowPos.Free;
    frmShowPos := nil;

  End;

end;

//====================================================================================================================//

procedure TfrmShowPos.btnCloseClick(Sender: TObject);
begin
  inherited;

  // vor dem Schließen auf GooglMaps stellen, sonst kommt Fehler und Form wird nicht freigegeben
  Map.BeginUpdate;
  Map.Service := msGoogleMaps;
  Map.EndUpdate;

  Close;

end;

//====================================================================================================================//

procedure TfrmShowPos.WebFormShow(Sender: TObject);
begin
  inherited;

  self.Left   := 0;
  self.Top    := 0;
  self.Width  := window.InnerWidth;
  self.Height := window.InnerHeight;
  Self.Resize;

  lbKennzeichen.Caption := '---';

end;

//====================================================================================================================//

procedure TfrmShowPos.btnFzgSel12Click(Sender: TObject);
var aModelResult : TModalResult;
    iNewID, iTab, iID_Fzg : Integer;
    sBez, sKennz : String;
    aModalResult : TModalResult;
begin
  inherited;

  iTab := c_Fzg;
  iID_Fzg := frmMainForm.iID_AktFzg;
  sBez   := '';
  iNewID := 0;

  aModalResult := await( TModalResult, Get_Stammdaten2( iTab, iID_Fzg, sBez ) );

  If aModalResult <> mrOK then Exit;

  self.iID_Fahrzeug := iID_Fzg;
  await( Fzg_Pos_Laden );

end;

//====================================================================================================================//

procedure TfrmShowPos.Fzg_Pos_Laden;
var Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    sDaten, sFelder, sSQL, sTmp, sZP, sLat, sLon, sKennz : String;
    aSL_Daten, aSL : TStringList;
    aStream : TStream;
    i, iAnz : Integer;
begin

  //console.log( 'Fzg_Pos_Laden - START' );

  If not WaitMessage.Showing then WaitMessage.Show;


  aSL_Daten := TStringList.Create;
  aSL := TStringList.Create;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;

    sSQL := '01:SELECT KENNZEICHEN, ZEITPUNKT, LATITUDE, LONGITUDE FROM FAHRZEUG F, FZG_KOOR K '
            +'  WHERE F.ID_FAHRZEUG=K.ID_FAHRZEUG AND K.ID_FAHRZEUG='+IntToStr(self.iID_Fahrzeug) ;

    sSQL := await(  Crypt( sSQL )  );

    Response :=  await( ClientConn.RawInvokeAsync('ISystemService.GetDatenPaket', [ sSQL, 0, 0 ] ) );
    Blob := Response.Result;
    asm sDaten = await Blob.text(); end;

  ClientConn.Free;



  aSL_Daten.Text := await( Crypt( sDaten ));

  iAnz := dmSpediFucs.Get_PaketDaten( aSL_Daten, aSL, '01');

  If aSL.Count > 2 then
    Begin
      sFelder := aSL[1];
      sDaten  := aSL[2];

      sLat   := GetFeldWert( sFelder, sDaten, 'LATITUDE' );
      sLon   := GetFeldWert( sFelder, sDaten, 'LONGITUDE' );
      sZP    := GetFeldWert( sFelder, sDaten, 'ZEITPUNKT' );
      sKennz := GetFeldWert( sFelder, sDaten, 'KENNZEICHEN' );

      sLat := ReplaceStr( sLat, '.', ',' );
      sLon := ReplaceStr( sLon, '.', ',' );

      dLat := SToF(sLat );
      dLon := SToF(sLon );

      lbKennzeichen.Caption := sKennz +'  -  '+sZP;

      Positionieren(nil);

    End;


  aSL.Free;
  aSL_Daten.Free;


  If not bUebersetzt then Form_Uebersetzen;

  WaitMessage.Hide;

  //console.log( 'Fzg_Pos_Laden - ENDE' );

end;

//====================================================================================================================//

procedure TfrmShowPos.Positionieren(Sender: TObject);
var aMarker: TTMSFNCMapsMarker;
begin
  inherited;

  //console.log('Positionieren-Start - Anz.Markers: '+inttostr(MAp.Markers.Count))  ;

  Try
    Map.BeginUpdate;
    Map.SetCenterCoordinate( self.dLat, self.dLon );

    Map.ClearMarkers ;
    Map.AddMarker(dLat, dLon, lbKennzeichen.Caption);

//    aMarker := Map.AddMarker(self.dLat, self.dLon);
//    aMarker.DefaultIcon.Enabled := True;
//    aMarker.DefaultIcon.Fill := clBlue;
//    aMarker.DefaultIcon.Size := 50;
//    aMarker.Title := lbKennzeichen.Caption;

  Finally
    Map.EndUpdate;
  End;


  //console.log('Positionieren-Ende')

end;

//====================================================================================================================//

procedure TfrmShowPos.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  lbKennzeichen := TLabel.Create(Self);
  btnClose := TTMSFNCToolBarButton.Create(Self);
  btnPosition := TTMSFNCToolBarButton.Create(Self);
  btnFzgSel12 := TTMSFNCToolBarButton.Create(Self);
  Map := TTMSFNCMaps.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  lbKennzeichen.BeforeLoadDFMValues;
  btnClose.BeforeLoadDFMValues;
  btnPosition.BeforeLoadDFMValues;
  btnFzgSel12.BeforeLoadDFMValues;
  Map.BeforeLoadDFMValues;
  tabSprachDaten.BeforeLoadDFMValues;
  try
    Width := 581;
    Height := 574;
    Caption := 'frmShowPos';
    Color := clBtnFace;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 581;
    WebPanel1.Height := 81;
    WebPanel1.Align := alTop;
    WebPanel1.ChildOrder := 2;
    WebPanel1.TabOrder := 0;
    lbKennzeichen.SetParentComponent(WebPanel1);
    lbKennzeichen.Name := 'lbKennzeichen';
    lbKennzeichen.Left := 11;
    lbKennzeichen.Top := 55;
    lbKennzeichen.Width := 105;
    lbKennzeichen.Height := 18;
    lbKennzeichen.Caption := 'RA -WS 800';
    lbKennzeichen.Font.Charset := ANSI_CHARSET;
    lbKennzeichen.Font.Color := clWindowText;
    lbKennzeichen.Font.Height := -16;
    lbKennzeichen.Font.Name := 'Verdana';
    lbKennzeichen.Font.Style := [fsBold];
    lbKennzeichen.HeightPercent := 100.000000000000000000;
    lbKennzeichen.ParentFont := False;
    lbKennzeichen.WidthPercent := 100.000000000000000000;
    btnClose.SetParentComponent(WebPanel1);
    btnClose.Name := 'btnClose';
    btnClose.Left := 8;
    btnClose.Top := 4;
    btnClose.Width := 90;
    btnClose.Height := 44;
    btnClose.Cursor := crHandPoint;
    btnClose.Hint := 'zur'#252'ck';
    btnClose.ParentDoubleBuffered := False;
    btnClose.DoubleBuffered := True;
    btnClose.Font.Charset := DEFAULT_CHARSET;
    btnClose.Font.Color := clWindowText;
    btnClose.Font.Height := -11;
    btnClose.Font.Name := 'Segoe UI';
    btnClose.Font.Style := [];
    btnClose.ParentColor := True;
    btnClose.TabOrder := 0;
    SetEvent(btnClose, Self, 'OnClick', 'btnCloseClick');
    btnClose.Text := '';
    btnClose.Bitmaps.Clear;
    with btnClose.Bitmaps.Add do
    begin
      Bitmap.LoadFromFile('ShowPos.btnClose.Bitmaps.Bitmap.png');
      BitmapName := 'LINKS';
    end;
    btnClose.BitmapVisible := True;
    btnClose.BitmapContainer := BitmapCont;
    btnClose.ControlIndex := 0;
    btnPosition.SetParentComponent(WebPanel1);
    btnPosition.Name := 'btnPosition';
    btnPosition.Left := 197;
    btnPosition.Top := 4;
    btnPosition.Width := 90;
    btnPosition.Height := 44;
    btnPosition.Cursor := crHandPoint;
    btnPosition.Hint := 'zentrieren';
    btnPosition.ParentDoubleBuffered := False;
    btnPosition.DoubleBuffered := True;
    btnPosition.Font.Charset := DEFAULT_CHARSET;
    btnPosition.Font.Color := clWindowText;
    btnPosition.Font.Height := -11;
    btnPosition.Font.Name := 'Segoe UI';
    btnPosition.Font.Style := [];
    btnPosition.ParentColor := True;
    btnPosition.TabOrder := 1;
    SetEvent(btnPosition, Self, 'OnClick', 'Positionieren');
    btnPosition.Text := '';
    btnPosition.Bitmaps.Clear;
    with btnPosition.Bitmaps.Add do
    begin
      BitmapName := 'POSITION';
    end;
    btnPosition.BitmapVisible := True;
    btnPosition.BitmapContainer := BitmapCont;
    btnPosition.ControlIndex := 0;
    btnFzgSel12.SetParentComponent(WebPanel1);
    btnFzgSel12.Name := 'btnFzgSel12';
    btnFzgSel12.Left := 103;
    btnFzgSel12.Top := 4;
    btnFzgSel12.Width := 90;
    btnFzgSel12.Height := 44;
    btnFzgSel12.Cursor := crHandPoint;
    btnFzgSel12.ParentDoubleBuffered := False;
    btnFzgSel12.DoubleBuffered := True;
    btnFzgSel12.Font.Charset := DEFAULT_CHARSET;
    btnFzgSel12.Font.Color := clWindowText;
    btnFzgSel12.Font.Height := -11;
    btnFzgSel12.Font.Name := 'Segoe UI';
    btnFzgSel12.Font.Style := [];
    btnFzgSel12.ParentColor := True;
    btnFzgSel12.TabOrder := 2;
    SetEvent(btnFzgSel12, Self, 'OnClick', 'btnFzgSel12Click');
    btnFzgSel12.Text := '';
    btnFzgSel12.Bitmaps.Clear;
    with btnFzgSel12.Bitmaps.Add do
    begin
      BitmapName := 'FAHRZEUG';
    end;
    btnFzgSel12.BitmapVisible := True;
    btnFzgSel12.BitmapContainer := BitmapCont;
    btnFzgSel12.ControlIndex := 0;
    Map.SetParentComponent(Self);
    Map.Name := 'Map';
    Map.Left := 0;
    Map.Top := 81;
    Map.Width := 581;
    Map.Height := 493;
    Map.Align := alClient;
    Map.ParentDoubleBuffered := False;
    Map.DoubleBuffered := True;
    Map.TabOrder := 1;
    SetEvent(Map, Self, 'OnMapInitialized', 'Positionieren');
    Map.Options.Locale := 'de-DE';
    Map.Options.DefaultLatitude := 48.858485144635100000;
    Map.Options.DefaultLongitude := 8.209359306124474000;
    Map.Options.DefaultZoomLevel := 15.000000000000000000;
    Map.Service := msLeaflet;
    tabSprachDaten.Left := 432;
    tabSprachDaten.Top := 8;
  finally
    WebPanel1.AfterLoadDFMValues;
    lbKennzeichen.AfterLoadDFMValues;
    btnClose.AfterLoadDFMValues;
    btnPosition.AfterLoadDFMValues;
    btnFzgSel12.AfterLoadDFMValues;
    Map.AfterLoadDFMValues;
    tabSprachDaten.AfterLoadDFMValues;
  end;
end;

end.
